import React, { useState, useEffect } from "react";
import { Tab, Nav } from "react-bootstrap";
import "./StarAuditionRoundInstructions.css";
import axios from "axios";
import moment from "moment";
import ReactPlayer from "react-player";
import PDF from "../../../../../assets/images/Pdf.png";
import { useHistory, useParams } from "react-router-dom";
import { Markup } from "interweave";
import noImage from "../../../../../assets/images/settings/no-image.png";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import cup from "../../../../../assets/images/page 1.png";
import swal from "sweetalert";
import ReUseableSingleRoundTab from "../../../../Reuseable/ReUseableSingleRoundTab";
import WaitingMessageComponent from "../../../../Reuseable/WaitingMessageComponent";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";

const StarAuditionRoundInstructions = (props) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const [isHaveInstruction, setIsHaveInstruction] = useState(false);
  const audition_id = props.match.params.audition_id;
  const [activeRound, setActiveRound] = React.useState(0);
  const [audition, setAudition] = React.useState({});
  const [auditionRounds, setAuditionRounds] = React.useState({});
  const [auditionInstructionSendInfo, setAuditionInstructionSendInfo] =
    useState({});
  const [loading, setLoading] = useState(true);
  const [file, setFile] = useState("");
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [filePdf, setFilePdf] = useState("");
  const [videoFile, setVideoFile] = useState("");
  const [convertedContent, setConvertedContent] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const history = useHistory();

  const fetchAuditionData = () => {
    axios.get(`/api/superstar/audition/details/${audition_id}`).then((res) => {
      if (res.data.status === 200) {
        setAudition(res.data.audition);
        setActiveRound(res.data.audition.active_round_info_id);
        setAuditionRounds(res.data?.audition?.info?.audition_rounds);
        setLoading(false);
      }
    });
  };
  const fethcRoundInstcructionSendInfo = () => {
    setLoading(true);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(
          `/api/superstar/audition/get-round-instruction-by-judge/${audition_id}/${activeRound}`
        )
        .then((res) => {
          if (res.data.status === 200) {
            setAudition(res.data.audition);

            if (res.data?.auditionRoundInstructionSendInfo == null) {
              setIsHaveInstruction(false);
              setFile("");
              setVideoFile("");
              setConvertedContent(null);
              setLoading(false);
            } else {
              setIsHaveInstruction(true);
              setConvertedContent(
                res.data?.auditionRoundInstructionSendInfo?.instruction
              );
              setFile(
                imageCdnUrl+res.data?.auditionRoundInstructionSendInfo?.image
              );
              setVideoFile(
                videoCdnUrl+res.data?.auditionRoundInstructionSendInfo?.video
              );
              setAuditionInstructionSendInfo(
                res.data?.auditionRoundInstructionSendInfo
              );
              setLoading(false);
            }
          }
        });
    });
  };

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
    setVideoFile(URL.createObjectURL(file[0]));
  };

  const handlePdfChange = (file) => {
    setFilePdf(file[0]);
  };

  const updateRoundInstructionInfo = (e) => {
    e.preventDefault();
    const fData = new FormData();
    fData.append("audition_id", audition.id);
    fData.append(
      "audition_round_instruction_send_info_id",
      auditionInstructionSendInfo.id
    );
    fData.append("instruction", convertedContent);
    fData.append("video", fileVideo);
    fData.append("image", imageData);
    fData.append("pdf", filePdf);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/superstar/audition/by-round-instruction-update`, fData)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            setAuditionInstructionSendInfo(
              res.data?.auditionRoundInstructionSendInfo
            );
          } else {
            setErrorList(res.data.validation_errors);
          }
        });
    });
  };
  useEffect(() => {
    fethcRoundInstcructionSendInfo();
  }, [activeRound]);

  useEffect(() => {
    fetchAuditionData();
  }, [audition_id]);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <div>
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={activeRound}
            >
              <div className="container-lg">
                <Nav variant="pills">
                  <div className="row">
                    {auditionRounds &&
                      auditionRounds.map((auditionRound, index) => (
                        <ReUseableSingleRoundTab
                          key={index}
                          auditionRound={auditionRound}
                          setActiveRound={setActiveRound}
                        />
                      ))}
                  </div>
                </Nav>
                <div className="my-4"></div>
              </div>
            </Tab.Container>
          </div>
          {isHaveInstruction ? (
            <>
              <div className="liveMeetupBorder">
                <div className="d-flex px-4">
                  <div className="faTrophy p-2">
                    <img src={cup} alt="" className="mt-1" width="30px" />{" "}
                    <span className="text-waning p-2 fw-bolder">
                      Round Instruction Info send
                    </span>
                  </div>
                </div>
                <div className="my-2">
                  <form
                    onSubmit={updateRoundInstructionInfo}
                    id="input_form"
                    encType="multipart/form-data"
                  >
                    <div className="row ms-5">
                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label text-light "
                        >
                          Post Title
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control Frombtns"
                            value={audition.title}
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="form-group row mt-3">
                        <label
                          for="inputPassword"
                          className="col-sm-2 col-form-label text-light "
                        >
                          Instruction
                        </label>
                        <div className="col-sm-8">
                          <CKEditor
                            editor={ClassicEditor}
                            data={convertedContent}
                            onChange={(audition, editor) => {
                              const data = editor.getData();
                              setConvertedContent(data);
                            }}
                          />
                          <span className="text-danger">
                            {errorList.instruction}
                          </span>
                        </div>
                      </div>
                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 col-form-label text-light "
                        >
                          Upload Video
                        </label>

                        <div className="col-sm-7 mb-2">
                          <div className="row my-4">
                            <div className="col-md-10">
                              {videoFile ? (
                                <>
                                  <ReactPlayer
                                    url={videoFile}
                                    // width="100%"
                                    controls={true}
                                    height="35vh"
                                  />
                                </>
                              ) : (
                                <></>
                              )}
                              <input
                                type="file"
                                name="file"
                                id="setFile"
                                className="inputfile w-25"
                                accept="video/mp4"
                                onChange={(e) =>
                                  handleVideoChange(e.target.files)
                                }
                              />

                              <label for="setFile">
                                <i className="fas fa-cloud-upload-alt"></i>{" "}
                                Upload Video
                              </label>
                              <span className="text-danger">
                                {errorList.video}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 col-form-label text-light "
                        >
                          Upload Banner
                        </label>

                        <div className="col-sm-7 mb-2">
                          <div className="row my-4">
                            {file ? (
                              <img
                                src={file}
                                alt="..."
                                className="demo-preview-image img-fluid"
                              />
                            ) : (
                              ""
                            )}
                            <div className="col-md-10">
                              <input
                                type="file"
                                name="imageFile"
                                id="imageFile"
                                className="inputfile w-25"
                                accept="image/jpg,image/jpeg, image/png"
                                onChange={(e) =>
                                  handleImageChange(e.target.files)
                                }
                              />

                              <label for="imageFile">
                                <i className="fas fa-cloud-upload-alt"></i>{" "}
                                Upload Image
                              </label>
                              <span className="text-danger">
                                {errorList.image}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 col-form-label text-light "
                        >
                          Instruction pdf for the post
                        </label>

                        <div className="col-sm-7 mb-2">
                          <div className="row d-flex justify-content-end my-4">
                            <div className="col-md-2 text-white"></div>
                            <div className="col-md-3 inputeParent">
                              <input
                                type="file"
                                name="pdfFile"
                                id="pdfFile"
                                accept=".pdf"
                                className="inputfile w-25"
                                onChange={(e) =>
                                  handlePdfChange(e.target.files)
                                }
                              />
                              <label for="pdfFile">
                                <i className="fa-solid fa-file-pdf"></i> 1 MB
                                Maximum
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-content-end my-4">
                        <div className="col-md-3 text-left">
                          <button
                            className="btn btn-warning px-4 fw-bold"
                            type="submit"
                          >
                            Confirm
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </>
          ) : (
            <>
              <WaitingMessageComponent message="You don't need to set any instructions for this round!" />
            </>
          )}
        </>
      )}
    </>
  );
};

export default StarAuditionRoundInstructions;
